module.exports = __webpack_public_path__ + "media/Video 144.06d2807b.mp4";